<template>
  <one-page-info-popup :cashflow-type="cashflowType">
    <cashflow-type-base-riseup-goal :is-preview-mode="true"/>
    <div class="info-popup-text">
      <span class="info-popup-title bold">יעד RiseUp</span>
      <span>
        המערכת מחשבת לפי החודשים הקודמים כמה כסף צפוי להשאר בצד בסוף החודש.
      </span>
      <span class="margin-top">
        הגדלה של יעד רייזאפ תצמצם את יתרת המשתנות, אבל יהיה אפשר לשים יותר כסף בצד כל חודש!
      </span>
      <callout class="margin-top-large" iconPath="icons/info-icon-blue.svg">
        <template v-slot:text>
          <div class="callout-text">
            כדי לדעת איזה יעד מתאים לך מומלץ להסתכל על סיכום החודשים הקודמים.
          </div>
        </template>
      </callout>
    </div>
  </one-page-info-popup>
</template>

<script>
import BaseUI from 'base-ui';
import cashflowViewConsts from '@/constants/cashflow-view';
import OnePageInfoPopup from './OnePageInfoPopup';

export default {
  name: 'RiseupGoalInfoPopup',
  components: {
    OnePageInfoPopup,
    CashflowTypeBaseRiseupGoal: () => import('../generic-components/cashflow-types/cashflow-types-base/CashflowTypeBaseRiseupGoal'),
    Callout: BaseUI.Callout,
  },
  computed: {
    cashflowType() {
      return cashflowViewConsts.cashflowTypes.riseupGoal;
    },
  },
};
</script>

<style scoped lang="scss">
@import "info-popups";

.callout-text {
  text-align: right;
}
</style>
